<template>
    <div>
        <el-dialog :title="titleName"
                   :visible.sync="dialogFormVisible"
                   class="wwweditcss"
                   width="66%">

            <div style="text-align: right;margin-bottom: 45px;">
                <div style="float: right">
                    <el-button v-if="$hasPerm('sys:user:add')" size="mini" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white;margin-left: 10px;">确认授权<i
                            class="el-icon-plus"></i>
                    </el-button>
                </div>
                <div style="float: right">
                    <el-select
                            v-model="form.ztId"
                            filterable
                            size="mini"
                            placeholder="请选择账套">
                        <el-option
                                v-for="item in ztList"
                                :key="item.id"
                                :label="item.qymc"
                                :value="item.id">
                        </el-option>
                    </el-select>

                </div>
            </div>

            <el-table
                    :data="tableData"
                    border
                    size="mini"
                    style="width: 100%;">
                <el-table-column prop="qymc" label="企业（账套）名称"></el-table-column>
                <el-table-column prop="kzzd" width="300" label="会计制度"></el-table-column>
                <el-table-column prop="nsrmc" width="180" label="纳税人名称"></el-table-column>
                <el-table-column prop="nsrcbh" width="180" label="纳税人识别号"></el-table-column>
                <el-table-column width="77" label="操作">
                    <template slot-scope="scope">
                        <a style="color: #409EFF;cursor: pointer;" @click="handleDelete(scope.row)">取消授权</a>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin-top: 5px;"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :page-sizes="[5, 10, 50, 100, 500]"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
            ></el-pagination>
        </el-dialog>
    </div>
</template>
<script>

    export default {
        name: 'userZtList',
        data() {
            return {
                currentPage: 1, //初始页
                pageSize: 10, //    每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                ztList: [],
                markName: '',
                username: '',
                name: '',
                titleName: '',
                form: {
                    ztId: '',
                    userId: ''
                },
                dialogFormVisible: false
            }
        },
        methods: {
            int(userId, username, name) {
                this.dialogFormVisible = true;
                this.getZtList();
                this.form.userId = userId;
                this.form.ztId = '';
                this.username = username;
                this.name = name;
                this.titleName = "账套授权：" + name + "[" + username + "]"
                this.handleCurrentChange(this.currentPage);
            },
            handleCurrentChange(cPage) {
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/sys/user/userZtList?td=' + new Date()),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'ztUserId': this.form.userId,
                        'markName': this.markName
                    }
                }).then(r => {
                    this.tableData = r.data.data.rows;
                    this.total = r.data.data.total;
                }).finally(r => {
                })

            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            handleAdd() {
                if (!this.form.ztId) {
                    this.$message({
                        type: 'warning',
                        message: "请选择授权账套"
                    })
                }
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/sys/user/userZtSave'),
                    method: 'post',
                    data: this.form
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange(1);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            },
            getZtList() {
                //查询数据库账套
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/sys/user/allList'),
                    method: 'get'
                }).then(r => {
                    this.ztList = r.data.data;
                })
            },
            handleDelete(row) {
                let from = {
                    ztId: row.id,
                    userId: this.form.userId
                }
                this.$confirm('确认取消授权?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/sys/user/userZtDelete'),
                        method: 'post',
                        data: from
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$notify({
                                title: '操作成功！',
                                type: 'success',
                                offset: 600
                            });
                            this.handleCurrentChange(1);
                        } else {
                            this.$message({ // 失败
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    }).finally(r => {
                    })
                }).catch(() => {
                });
            }
        }
    }
</script>
<style scoped>

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .wwweditcss >>> .el-dialog__body {
        padding: 10px 35px 25px 35px;
    }

</style>